<template>
  <div class="addMetting">

    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="right" label-width="120px" class="demo-ruleForm">

      <el-row>
        <el-col :span="10">
          <el-form-item label="会议头像" prop="region">
            <el-select v-model="ruleForm.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai"/>
              <el-option label="区域二" value="beijing"/>
            </el-select>
          </el-form-item>
          <el-form-item label="会议名称" prop="mettingIcon">
            <el-input v-model="ruleForm.mettingIcon"/>
          </el-form-item>
          <el-form-item label="可容纳人数" prop="num">
            <el-input v-model.number="ruleForm.num"/>
          </el-form-item>
          <el-form-item label="备注" prop="beizhu">
            <el-input
              v-model="ruleForm.beizhu"
              type="text"
              placeholder="请输入"
              maxlength="100"
              show-word-limit/>
          </el-form-item>

          <el-form-item label="会议室设备" prop="setting">
            <el-select v-model="ruleForm.setting" placeholder="请选择">
              <el-option label="区域一" value="shanghai"/>
              <el-option label="区域二" value="beijing"/>
            </el-select>
          </el-form-item>
          <el-form-item label="会议室状态" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择">
              <el-option label="区域一" value="shanghai"/>
              <el-option label="区域二" value="beijing"/>
            </el-select>
          </el-form-item>

        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="10">
          <el-form-item label="会议室地址" prop="address">
            <el-input v-model="ruleForm.address"/>
          </el-form-item>
          <el-form-item label="会议室管理员" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择">
              <el-option label="区域一" value="shanghai"/>
              <el-option label="区域二" value="beijing"/>
            </el-select>
          </el-form-item>
          <el-form-item label="管理员电话" prop="beizhu">
            <el-input v-model="ruleForm.beizhu"/>
          </el-form-item>
          <el-form-item label="会议创建人" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择">
              <el-option label="区域一" value="shanghai"/>
              <el-option label="区域二" value="beijing"/>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" required>
            <el-date-picker
              v-model="value1"
              type="datetime"
              placeholder="选择日期时间"/>
          </el-form-item>
          <el-form-item label="最后修改时间" required>
            <el-date-picker
              v-model="value1"
              type="datetime"
              placeholder="选择日期时间"/>
          </el-form-item>

        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        date1: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ],
        type: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '请填写活动形式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

            <style scoped>
              .addMetting{
                  height: 100vh;
                  background: linear-gradient(180deg, rgba(187, 180, 180, 0), rgba(175, 174, 174, 0.336));
              }
              .el-select {
              width: 100%;
              }

              .el-form-item{
                  /* margin-bottom: 3px; */
              }
              .el-form--label-top .el-form-item__label{
                  padding:0;
              }
            </style>
